import * as types from './mutation-types'

export const emptyAction = ({ commit }, item) => {};